import * as React from 'react';

import { InterventionScenario } from './InterventionScenario';
import { InterventionsEmptyState } from './InterventionsEmptyState';
import { ErpScenarioResponse, VirtualPackErpResponse } from 'com.cogvio.pricemonitor.api';
import { ERPApiResult } from '~/libs/infrastructure/schemas/erp';

export interface ErpScenarioWithData extends ErpScenarioResponse {
	data?: VirtualPackErpResponse;
	parseErpResults?: ERPApiResult;
}

interface InterventionsProps {
	currency: string;
	scenariosResults: ErpScenarioWithData[];
	virtualProductPackName: string;
	loading: boolean;
	onNewScenarioCreate: () => void;
	onScenarioEdit: (name: string) => void;
}

export function Interventions({
	currency,
	scenariosResults,
	virtualProductPackName,
	loading,
	onNewScenarioCreate,
	onScenarioEdit,
}: InterventionsProps) {
	return (
		<div className='px-10 bg-white border-b-2 border-gray-300'>
			<div className='pt-10 pb-12 w-full max-w-7xl mx-auto text-center'>
				<div className='pb-2 flex justify-between items-center'>
					<h2 className='font-display text-h2-head font-semibold text-cPurple-600'>Intervention Scenarios</h2>
					<button className='btn-second' onClick={onNewScenarioCreate}>
						<svg
							className='inline-block relative -mt-0.5 h-4 w-4'
							fill='none'
							stroke='currentColor'
							viewBox='0 0 24 24'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								d='M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
							></path>
						</svg>
						&nbsp;Create new scenario
					</button>
				</div>
				{(scenariosResults || []).length > 0 ? (
					scenariosResults.map((scenario, index) => (
						<InterventionScenario
							currency={currency}
							index={index + 1}
							key={scenario.id}
							scenarioData={scenario.data}
							parseErpResults={scenario.parseErpResults}
							scenario={scenario}
							loading={loading}
							virtualProductPackName={virtualProductPackName}
							onScenarioEdit={onScenarioEdit}
						/>
					))
				) : (
					<InterventionsEmptyState />
				)}
			</div>
		</div>
	);
}
